import firebase from "@firebase/app";
import moment from '@/moment-gp'

/* =============================================================================
DB:       Realtime DB
PATH:     user.{userId}.userlog.{logUUID}
PURPOSE:  Log everything the user is doing and try to learn from it
============================================================================= */

export default {
  create({ taskId, actionType }) {

    const action_types = [
      'MOVED_TO_NEXT_DAY',
      'MOVED_ON_SAME_DAY',
      'TASK_DONE_ON_TIME',
      'TASK_DONE_WITH_OVERTIME',
      'TASK_FAILED',
      'TASK_NOT_STARTED',
      'TASK_ADDED_TIME',
      'PAUSE_INCREASED',
      'START_OF_DAY_UPDATED',
      'GOAL_COMMITMENT_UPDATED',
      'WEEKLY_COMMITMENT_UPDATED',
      'DURATION_UPDATED',
      'DIFFICULTY_UPDATED',
      'GOALLANE_CREATED',
      'GOALLANE_JOINED',
      'GOALLANE_LEFT',
      'GOALLANE_DELETED',
      'LIKED' ];

    if ( !action_types.includes( actionType ) ) {
      console.warn('Invalid action type', actionType );
    }

    let log = {
      createdAt:    firebase.database.ServerValue.TIMESTAMP,
      taskId:       taskId,       // UUID
      actionType:   actionType,   //
      fromTime:     moment.currentTime().toRealtimeDB(), // Date.now(),   // TODO: toISOString()? (new Date()).getTime()
      toTime:       moment.currentTime().toRealtimeDB(), // Date.now(),   // TODO: toISOString()? (new Date()).getTime()
      amount:       null
    };

    return log;
  },

  fields: {
    createdAt: { validate_bolt_type: 'ServerTimestamp' },
    taskId: { validate_bolt_type: 'AnyID' },
    actionType: { validate_bolt_type: 'String' },
    fromTime: { validate_bolt_type: 'Timestamp' },
    toTime: { validate_bolt_type: 'Timestamp' },
    amount: { validate_bolt_type: 'Number' },
  }
};
